module.exports = __webpack_public_path__ + "static/media/comment-smile.7f9fdb59.svg";